import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';


@Component({
  selector: 'app-order-show',
  templateUrl: './order-show.component.html',
  styleUrls: ['./order-show.component.css']
})
export class OrderShowComponent implements OnInit {

  constructor() { }
  @Input() order;
  @Output() contactClick :  EventEmitter<any>  = new EventEmitter();
  ngOnInit() {
  }
  openContactModal(){
     this.contactClick.emit(this.order);
  }

  location(order) {
    if(order.event.onlineLocationChoice === 'evenemet_en_ligne')
      return order.event.onlineLink;
    return order.event.location_name+'-'+order.event.zipcode+' '+order.event.city
  }
  showOnlineDeadlineStatut() {
    for(let i=0;i<this.order.deadlines.length;i++) {
      if(this.order.deadlines[i].mailSended && !this.order.deadlines[i].payed) {
        return true
      }
    }
    return false;
  }
}
